import { landingCopy } from "../landingCopy"
import { useLandingLanguage } from "../useLandingLanguage"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function OmnichannelSection() {
  const language = useLandingLanguage()
  const omnichannel = landingCopy(language, "omnichannel")

  return (
    <section className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-col items-start gap-8">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">
          {omnichannel.stamp}
        </p>
        <h2 className={headingClass}>{omnichannel.title}</h2>
      </div>
      <p className="max-w-[68ch] text-[18px] font-normal leading-7 text-[#4D4D4D]">
        {omnichannel.body}
      </p>
      <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">
        {omnichannel.channels}
      </p>
    </section>
  )
}
